import questionAPI from "../../api/question"
import uuidv4 from "uuid/v4"
import { getItem, setItem } from "../../plugins/localStorage"

const state = {
  guid_text: null,
  title: null,
  type: null,
  max_chars: 0,
  attendees: 0,
  connected: 0,
  created_at: null,
  updated_at: null,
  event_guid_text: null,
  user_guid_text: null,
  likes_max: 0,
  isAttendeesContributionsLimitByLabel: false,
  attendeesContributionsLimit: "free",
  isQuestionContributionsLimitByLabel: false,
  questionContributionsLimit: "free",
  can_like: false,
}

const getters = {
  getQuestionGuid: (state) => {
    return state.guid_text
  },
}

const actions = {
  async syncFromDb({ state, dispatch, commit }, question_guid = null) {
    console.log("sync from db...")
    if (question_guid === null) {
      question_guid = state.guid_text
      if (state.created_at === null) {
        this._vm.$toasted.global.smartq_error({
          message: "La question " + question_guid + " n'existe pas en base de données.",
        })
        return
      }
    } else {
      dispatch("app/attachQuestionToSlide", question_guid, { root: true })
    }

    setItem({
      name: "lastGroupIndex[" + question_guid + "]",
      value: null,
    })
    setItem({
      name: "groups[" + question_guid + "]",
      value: null,
    })
    setItem({
      name: "selectedLabels[" + question_guid + "]",
      value: null,
    })
    setItem({
      name: "answersOrder[" + question_guid + "]",
      value: null,
    })
    setItem({
      name: "stack",
      value: [],
    })
    setItem({
      name: "question[" + question_guid + "]",
      value: null,
    })

    await dispatch("app/setQuestion", null, { root: true })

    // commit("live/setInactive", false, { root: true })
  },

  async newQuestion({ dispatch, commit, rootState }) {
    const question_guid = uuidv4().toUpperCase()
    const question = {
      guid_text: question_guid,
      title: rootState.app.slideMetadata.title,
      type: "BRAINSTORM",
      max_chars: 120,
      // created_at: created_at,
      likes_max: 0,
      isAttendeesContributionsLimitByLabel: false,
      attendeesContributionsLimit: "free",
      isQuestionContributionsLimitByLabel: false,
      questionContributionsLimit: "free",
      attendees: 0,
      connected: 0,
      can_like: true,
    }
    commit("answers/setAnswers", [], { root: true })
    commit("labels/setLabels", [], { root: true })
    commit("question/setQuestion", question, { root: true })
    this.commit(
      "offline/addApiCallToStack",
      {
        api: "question",
        method: "newQuestion",
        arg: question,
      },
      { root: true }
    )
    setItem({ name: "question[" + question.guid_text + "]", value: question })

    const label = await dispatch(
      "labels/newLabel",
      {
        text: "Sans label",
        initials: "SL",
        color: "pastel-1",
        is_for_pilot_only: true,
        is_default: true,
        order: 1,
      },
      { root: true }
    )

    console.log("new label", label)

    dispatch("answers/newAnswer", { text: "Modèle de contribution", label_guid: label.guid_text }, { root: true })
  },

  update({ state }) {
    questionAPI.updateQuestion(state)
  },

  updateLocal({ state }, property) {
    let question = getItem("question[" + state.guid_text + "]")
    question[property] = state[property]
    setItem({ name: "question[" + question.guid_text + "]", value: question })
  },

  async uploadToDB({ state, rootState, commit, dispatch }) {
    const launchedQuestions = getItem("launchedQuestions")

    if (
      launchedQuestions === null ||
      launchedQuestions.findIndex((question) => question.guid_text === state.guid_text) === -1
    ) {
      setItem({
        name: "launchedQuestions",
        value: [
          {
            guid_text: state.guid_text,
            launched_at: Date.now(),
          },
          ...(launchedQuestions !== null ? launchedQuestions : []),
        ],
      })
      dispatch("answers/deleteModelAnswer", null, { root: true })
    }

    // if question has been already launched, update it
    if (
      launchedQuestions !== null &&
      launchedQuestions.findIndex((question) => question.guid_text === state.guid_text) !== -1
    ) {
      /* USELESS, we already know pilot and event
      if (window.Office) {
        // retrieve Pilot and envent_guid infos from local ppt socket
        await dispatch("socketppt/getPilot", null, { root: true })
        await dispatch("socketppt/getEvent", null, { root: true })
        commit("setEventGuidText", rootState.pilot.event_guid)
        commit("setUserGuidText", rootState.pilot.user.id_text)
      }*/

      // delete all user likes answers
      // questionAPI.deleteAllUserLikesAnswer(state.guid_text)

      await questionAPI.updateQuestion(state)
    }

    await dispatch("offline/unstackApiCalls", null, { root: true })
  },
}

const mutations = {
  setCreatedAt(state, created_at) {
    state.created_at = created_at
    this.dispatch("question/updateLocal", "created_at")
  },

  setUpdatedAt(state, updated_at) {
    state.updated_at = updated_at
    this.dispatch("question/updateLocal", "updated_at")
  },

  duplicate(state, { answers, labels }) {
    const question = {
      guid_text: state.guid_text,
      title: state.title,
      type: state.type,
      max_chars: state.max_chars,
      likes_max: state.likes_max,
      isAttendeesContributionsLimitByLabel: state.isAttendeesContributionsLimitByLabel,
      attendeesContributionsLimit: state.attendeesContributionsLimit,
      isQuestionContributionsLimitByLabel: state.isQuestionContributionsLimitByLabel,
      questionContributionsLimit: state.questionContributionsLimit,
      can_like: state.can_like,
      answers: answers,
      labels: labels,
    }
    this.dispatch("app/attachQuestionToSlide", state.guid_text, { root: true })
    setItem({ name: "question[" + question.guid_text + "]", value: question })
  },

  setLikesMax(state, likesMax) {
    if (state.likes_max < likesMax) {
      state.likes_max = likesMax
      this.dispatch("question/updateLocal", "likes_max")
    }
  },

  setConnected(state, connected) {
    state.connected = connected
    this.dispatch("question/updateLocal", "connected")
  },

  setAttendees(state, attendees) {
    state.attendees = attendees
    this.dispatch("question/updateLocal", "attendees")
  },

  setEventGuidText(state, event_guid) {
    state.event_guid_text = event_guid
    this.dispatch("question/updateLocal", "event_guid_text")
  },

  setUserGuidText(state, user_guid) {
    state.user_guid_text = user_guid
    this.dispatch("question/updateLocal", "user_guid_text")
  },

  toggleIsAttendeesContributionsLimitByLabel(state) {
    state.isAttendeesContributionsLimitByLabel = !state.isAttendeesContributionsLimitByLabel
  },

  toggleIsQuestionContributionsLimitByLabel(state) {
    state.isQuestionContributionsLimitByLabel = !state.isQuestionContributionsLimitByLabel
  },

  setAttendeesContributionsLimit(state, limit) {
    state.attendeesContributionsLimit = limit
    this.dispatch("question/updateLocal", "attendeesContributionsLimit")
  },

  setQuestionContributionsLimit(state, limit) {
    state.questionContributionsLimit = limit
    this.dispatch("question/updateLocal", "questionContributionsLimit")
  },

  setMaxChars(state, max_chars) {
    state.max_chars = max_chars
    this.dispatch("question/updateLocal", "max_chars")
  },

  setCanLike(state, can_like) {
    state.can_like = can_like
    this.dispatch("question/updateLocal", "can_like")
  },

  setGuid(state, guid_text) {
    state.guid_text = guid_text
  },

  setQuestion(state, question) {
    // force watcher even if same guid
    state.guid_text = null
    for (const property in question) {
      state[property] = question[property]
    }
  },

  setTitle(state, title) {
    state.title = title
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
